/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IContentBlockTeamViewProps } from './obrien-content-block-team';

const ContentBlockTeamView: React.FC<IContentBlockTeamViewProps> = props => {
    const { contentBlockContainer, imageContainer, detailsContainer, title, text, links, image, outboundLink } = props;
    return (
        
        <Module {...contentBlockContainer}>
            {image ? (
                <>
                <Node {...imageContainer}>
                {outboundLink ? (    
                    <a target='_blank' href={outboundLink}>
                        {image}
                    </a>      
                ) : (
                    <>{image}</>
                )}
                    
                </Node>
                <Node {...detailsContainer}>
                    <div className='ind-img'>
                        
                        <div>
                            {title}
                            {text}
                            {links}
                        </div>
                      
                    </div>
                </Node>
                </>
            ) : 
            (
                <div className='center-vertically team-first'>
                <Node {...detailsContainer}>
                    <div className='ind-no-img'>
                        <div>
                            {title}
                            {text}
                            {links}
                        </div>
                    </div>
                </Node>
                </div>
            ) }
        </Module>
        
    );
};

export default ContentBlockTeamView;
